"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DiamondXSolid: function() {
        return DiamondXSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const DiamondXSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M1.99985 13.4143C1.2188 12.6332 1.2188 11.3669 1.99985 10.5858L5.58573 6.99995L10.5858 12L5.58569 17.0001L1.99985 13.4143Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M6.9999 18.4143L10.5857 22.0001C11.3668 22.7812 12.6331 22.7812 13.4141 22.0001L17 18.4142L12 13.4142L6.9999 18.4143Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M18.4142 17L22 13.4143C22.781 12.6332 22.781 11.3669 22 10.5858L18.4142 7.00003L13.4142 12L18.4142 17Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M17 5.58581L13.4141 1.99997C12.6331 1.21892 11.3668 1.21892 10.5857 1.99997L6.99994 5.58573L12 10.5858L17 5.58581Z",
            fill: "currentColor"
        })
    ]
}), "DiamondXSolid");
const _default = DiamondXSolid;
